import config_ from '../../../../../lib/config';
// This is really a hacky workaround ⚠️
const config = config_;
export const isInPrebidPermutiveTest = () => config.get('tests.prebidWithPermutiveVariant', '') === 'variant';
